import { c as _c } from "react/compiler-runtime";
import * as Sentry from "@sentry/nextjs";
import { isEnum, isType } from "forms/helpers/checkJsonSchemaType";
import parseArray from "forms/helpers/parsers/parseArray";
import parseBoolean from "forms/helpers/parsers/parseBoolean";
import parseCvField from "forms/helpers/parsers/parseCvField";
import parseDate from "forms/helpers/parsers/parseDate";
import parseEnum from "forms/helpers/parsers/parseEnum";
import parseLanguagesField from "forms/helpers/parsers/parseLanguagesField";
import parseNull from "forms/helpers/parsers/parseNull";
import parseNumber from "forms/helpers/parsers/parseNumber";
import parseObject from "forms/helpers/parsers/parseObject";
import parsePhoneField from "forms/helpers/parsers/parsePhoneField";
import parseString from "forms/helpers/parsers/parseString";
import { useIntl } from "react-intl";
import type { IProperty } from "types/jsonSchema";
import { predefinedFields } from "types/predefinedFields";
import { z } from "zod";
export default function useParseSchema() {
  const $ = _c(2);
  const {
    formatMessage
  } = useIntl();
  let t0;
  if ($[0] !== formatMessage) {
    const selectParser = (fieldName, field) => {
      if (fieldName === predefinedFields.languages) {
        return parseLanguagesField(field, formatMessage);
      }
      if (fieldName === predefinedFields.phone) {
        return parsePhoneField(field, formatMessage);
      }
      if (fieldName === predefinedFields.cvFiles) {
        return parseCvField(field, formatMessage);
      }
      if (field.format === "date") {
        return parseDate(field);
      }
      if (isEnum(field)) {
        return parseEnum(field, formatMessage);
      }
      if (isType(field.type, "array")) {
        return parseArray(field, formatMessage);
      }
      if (isType(field.type, "object")) {
        return parseObject(field);
      }
      if (isType(field.type, "boolean")) {
        return parseBoolean();
      }
      if (isType(field.type, "string")) {
        return parseString(field, formatMessage);
      }
      if (isType(field.type, "integer")) {
        return parseNumber(field);
      }
      return z.any();
    };
    const parse = t1 => {
      const {
        fieldName: fieldName_0,
        field: field_0,
        isRequired
      } = t1;
      const schema = selectParser(fieldName_0, field_0);
      const nullParsed = parseNull(field_0, schema, isRequired);
      return nullParsed;
    };
    const parseSchema = (toParse, required) => {
      ;
      try {
        const formSchema = Object.keys(toParse).reduce((acc, field_1) => {
          const schema_0 = parse({
            fieldName: field_1,
            field: toParse[field_1],
            isRequired: required.includes(field_1)
          });
          if (!schema_0) {
            return acc;
          }
          Object.assign(acc, {
            [field_1]: schema_0
          });
          return acc;
        }, {});
        const zodSchema = z.looseObject(formSchema);
        return zodSchema;
      } catch (t2) {
        const e = t2;
        Sentry.captureException(e);
        return null;
      }
    };
    t0 = {
      parseSchema
    };
    $[0] = formatMessage;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}